var exports = {
  "i": "xa15a2ab7--925121--wrapper",
};

module.exports = exports;
